// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCountdown, useValidateOtp, useReSendOtp } from "../../hooks";
import {
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
  Link,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Loading } from "..";
import { useUserInfo } from "../../store/User.state";
import { useSetSnackBar } from "../../store/Snackbar.state";

import { ChangePasswordModal } from "../../components";

const COUNTDOWN_SECONDS = 90;

interface OtpFormModalProps {
  isOpen: boolean;
}

export const OtpFormModal = ({ isOpen }: OtpFormModalProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { mutate: validateOtp, isLoading } = useValidateOtp();
  const { mutate: reSendOtp } = useReSendOtp();
  const [userInfo] = useUserInfo();
  const { minutesText, secondsText, resetCountdown } =
    useCountdown(COUNTDOWN_SECONDS);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);
  const navigate = useNavigate();
  const setSnackbar = useSetSnackBar();
  const numberOfDigits = 6;
  const [otp, setOtp] = useState(new Array(numberOfDigits)?.fill(""));
  const otpBoxReference = useRef([]);

  function handleChange(value, index) {
    if (/^\d?$/.test(value)) {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);

      if (value && index < numberOfDigits - 1) {
        otpBoxReference?.current[index + 1].focus();
      }
    }
  }

  function handleBackspaceAndEnter(e, index) {
    const input = e.target;
    if (e.key === "Backspace" && !input.value && index > 0) {
      otpBoxReference.current[index - 1].focus();
    } else if (e.key === "Enter" && input.value && index < numberOfDigits - 1) {
      otpBoxReference.current[index + 1].focus();
    }   if (e.key === "ArrowLeft") {
      if (index === 0) {
        e.preventDefault();
      } else {
        otpBoxReference.current[index - 1].focus();
        setTimeout(() => {
          const previousInput = otpBoxReference.current[index - 1];
          if (previousInput) {
            previousInput.setSelectionRange(previousInput.value.length, previousInput.value.length);
          }
        });
      }
    }
   else if (e.key === "ArrowRight" && index < numberOfDigits - 1) {
      otpBoxReference.current[index + 1].focus();
      setTimeout(() => {
        const nextInput = otpBoxReference.current[index + 1];
        if (nextInput) {
          nextInput.setSelectionRange(nextInput.value.length, nextInput.value.length);
        }
      });
    }
  }
 
  
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        otpBoxReference.current[0]?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    const otpCode = otp.join("");
    if (otpCode?.length === numberOfDigits) {
      validateOtp(
        { otpCode: otpCode },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              if (userInfo.systemPassword) {
                setIsChangePasswordModalOpen(true);
              } else {
                setSnackbar({
                  severity: "success",
                  isOpen: true,
                  description: data.message,
                });
                navigate("/dashboard");
              }
            } else {
              setSnackbar({
                severity: "error",
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              description: "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          },
        }
      );
    }
  }, [navigate, validateOtp,  userInfo, otp]);

  const callReSendOtp = () => {
    reSendOtp(
      {},
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
            setOtp(new Array(numberOfDigits).fill(""));
            resetCountdown();
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  return (
    <>
      {isLoading && <Loading />}
      <Modal
        sx={{ justifyContent: "center", alignItems: "center" }}
        open={isOpen}
      >
        <Stack
          sx={{
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            padding: "2%",
          }}
        >
          <Stack
            borderRadius={2}
            p={isDesktop ? 8 : 2}
            sx={{
              backgroundColor: "white",
              width: isDesktop ? 568 : "90%",
              maxHeight: "71vh",
              boxShadow: 10,
            }}
          >
            <Typography mb={2} color="text.default" variant="h3">
              Onay Kodu
            </Typography>
            <Typography
              color="text.default"
              variant="body1"
            >{`Lütfen ${userInfo.phoneNumber} numaralı telefona gönderilen onay kodunu girin. Telefon numarası doğru değilse yardım adımından destek alabilirisiniz.`}</Typography>
            <Typography
              my={isDesktop ? 5 : 2}
              color="text.subtle"
              variant="h4"
              sx={{ textAlign: "center" }}
            >{`${minutesText}:${secondsText}`}</Typography>
            <Stack
              width={isDesktop ? "100%" : "100%"}
              justifyContent="center"
              alignItems="center"
            >
              <Stack flexDirection={"row"}>
                {otp?.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    className="otp-field__input"
                    value={digit}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyDown={(e) => handleBackspaceAndEnter(e, index)}
                    ref={(el) => (otpBoxReference.current[index] = el)}
                    autoFocus={index === 0}
                    inputMode="numeric"
                    style={{
                      width: isDesktop ? "48px" : "30px",
                      marginRight: isDesktop ? "10px" : "5px",
                      boxSizing: "border-box",
                    }}
                  />
                ))}
              </Stack>
            </Stack>

            <Stack mt={5} justifyContent="center" alignItems="center">
              <Button
                onClick={() => console.log("")}
                sx={{ width: 240, mb: 3 }}
                size="medium"
                variant="contained"
                text="Onayla"
              />
              <Link
                component="button"
                variant="body2"
                sx={{ alignItems: "rigth" }}
                onClick={() => {
                  callReSendOtp();
                }}
              >
                <Typography
                  sx={{ textAlign: "center", textDecoration: "underline" }}
                  color="primary.dark"
                  variant="body2"
                >
                  Tekrar Gönder
                </Typography>
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Modal>

      {isChangePasswordModalOpen && (
        <ChangePasswordModal
          isOpen={isChangePasswordModalOpen}
          onClose={() => {
            setIsChangePasswordModalOpen(false);
            navigate(0);
          }}
        />
      )}
    </>
  );
};
